var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppointmentMedium } from 'constants/appointmentMedium';
import { VideoChat } from 'shared/assets/icons';
import { FiPhone } from 'react-icons/fi';
import { Icon, Link, Text, Flex, Button } from 'shared/components';
import { formatPhoneNumber } from 'shared/utils';
import { useAppointmentLocation } from '../hooks';
export var AppointmentLocationLink = function (_a) {
    var medium = _a.medium, location = _a.location, memberId = _a.memberId, ownerId = _a.ownerId;
    if (!medium || !location || !memberId)
        return null;
    var parsedLocation = useAppointmentLocation(medium, location, memberId, ownerId);
    var formatted = formatPhoneNumber(parsedLocation !== null && parsedLocation !== void 0 ? parsedLocation : '');
    if (medium === AppointmentMedium.video) {
        return (_jsx(Link, __assign({ href: parsedLocation !== null && parsedLocation !== void 0 ? parsedLocation : '', target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(Button, __assign({ "data-testid": "zoom-link", variant: "blueLinks", leftIcon: _jsx(Icon, { as: VideoChat, boxSize: 4 }), pl: 0, height: 3 }, { children: "Open video call" })) })));
    }
    else if (medium === AppointmentMedium.phone) {
        return (_jsxs(Flex, __assign({ alignContent: "center", direction: "row" }, { children: [_jsx(Icon, { as: FiPhone, boxSize: 4, ml: 2, marginRight: "10px" }), _jsx(Text, __assign({ paddingRight: 4 }, { children: formatted.fullNumber }))] })));
    }
    else {
        // AP: fill in the other two when Josh gives us ui direction
        return null;
    }
};
